import { create } from 'zustand';

export interface TaskInfo {
  codigo: string;
  task_id: string;
  startTime: number;
}

export interface ProgressState {
  estado: 'PENDIENTE' | 'PROCESANDO' | 'COMPLETADO' | 'ERROR';
  progreso: number;
  total: number;
  porcentaje: number;
  descripcion: string;
  error?: string;
}

interface GlobalProgressBarState {
  // State
  currentTask: TaskInfo | null;
  progressState: ProgressState | null;
  isVisible: boolean;

  // Actions
  setTask: (task: TaskInfo) => void;
  updateProgress: (progress: ProgressState) => void;
  clearTask: () => void;
  setVisible: (visible: boolean) => void;
}

export const useGlobalProgressBarStore = create<GlobalProgressBarState>((set) => ({
  // Initial state
  currentTask: null,
  progressState: null,
  isVisible: false,

  // Actions
  setTask: (task) => {
    set({
      currentTask: task,
      progressState: {
        estado: 'PENDIENTE',
        progreso: 0,
        total: 0,
        porcentaje: 0,
        descripcion: 'Iniciando procesamiento...',
      },
      isVisible: true,
    });
  },

  updateProgress: (progress) => {
    set({ progressState: progress });
  },

  clearTask: () => {
    set({
      currentTask: null,
      progressState: null,
      isVisible: false,
    });
  },

  setVisible: (visible) => {
    set({ isVisible: visible });
  },
}));
